export default __webpack_public_path__ + "static/media/TM.f902dd65.svg";